import { toPathFactories } from '../toPathFactories'
import RailsRoutes from './RailsRoutes'

export default toPathFactories(RailsRoutes)
